<template>
    <div v-if="loginzt" style="width: 40%">
        <el-form ref="form" :model="form" label-width="80px">
            <div class="formElement">
                <el-form-item label="人员编号">
                    <el-input type="text" v-model="form.rybh" autoComplete="on" placeholder="人员编号"></el-input>
                </el-form-item>
                <el-form-item label="验证码">
                    <el-input type="text" v-model="form.yzm" autoComplete="on" placeholder="验证码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">登录</el-button>
                    <!--            <el-button>取消</el-button>-->
                </el-form-item>
            </div>
        </el-form>
    </div>
    <div v-else>
        <el-card class="box-card">
            <div class="text item">
            <h3>{{this.title}}</h3>
            <el-form ref="editForm" :model="editForm" label-width="120px" label-position="left" :rules="EditRules" v-loading="loading" element-loading-text="拼命加载中">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="考试编号">
                            {{ editForm.ksbh }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证书名称">
                            {{ formatzsmc(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="课程名称">
                            {{ editForm.kcmc }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="考试日期" prop="ksrq">
                            {{editForm.ksrq}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="考试时间" prop="examTime">
                            {{formatkssj(editForm)}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="考评员" prop="jkry">
                            {{ formatjkry(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="督导人员" prop="ddry">
                            {{ formatddry(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="考务人员" prop="xkry">
                            {{ formatxkry(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="考试场地" prop="kscd">
                            {{ formatkscd(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="考试情况">
                            {{ formatksqk(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="text-align: center">
                    <el-button v-show="buttomShow" type="success" size="small" @click="sfjsksap('2')">接受</el-button>
                    <el-button v-show="buttomShow" type="danger" size="small" @click="sfjsksap('3')">拒绝</el-button>
                </el-row>
            </el-form>
            </div>
        </el-card>
        <el-dialog class="customElRow" :title="signDialogTitle" :visible.sync="signVisable" @closed="closeSignDialog" width="800px" top="150px">
            <vue-esign id='esign' ref="esign" :width='920' :height="460" style="border: 1px dashed #c2c1c1;" :isCrop="false" :lineWidth="6" lineColor="#000000" bgColor.sync=""/>
            <el-button style="margin: 0px 20px;" type="success" @click="esignSave()">确 认</el-button>
        </el-dialog>
    </div>

</template>

<script>
import {confirmMsg, showNotify} from "utils/message";
export default {
    name: "evaluatorsLogin",
    data() {
        return {
            form: {
                rybh: '',
                yzm: '',
            },
            loginzt: true,
            zsmc: [],//证书名称下拉数据
            ksqk: [],//考试情况下拉数据
            people: [],//人员下拉框数据
            site: [],//考试场地下拉框数据
            site2: [],//考试场地下拉框数据
            address: [],//考试场地地址下拉框数据
            editForm: {
                id: null,
                ksbh: null,//考试编号
                zsmc: null,//证书名称
                kcbh: null,//课程编号
                kcmc: null,//课程名称
                ksrq: null,//考试日期
                kskssj: null,//考试开始时间
                ksjssj: null,//考试结束时间
                jkry: null,//监考人员
                ddry: null,//督导人员
                xkry: null,//巡考人员
                zkry: null,//主考人员
                kscd: null,//考试场地
                kscc: null,//考试场次
                kskcbid: null,//考试课程表编号
                ksqk: null,//考试情况
            },
            EditRules: {},
            loading: false,
            title: '',
            sfjsMessage: null,
            //签名弹框
            signDialogTitle: "签名",
            signVisable: false,

            sfjs: null,

            ksapid: null,
            jklx: null,
            buttomShow: true,
        }
    },
    created() {

        this.initCombo();

    },
    methods: {
        onSubmit() {
            console.log('submit!');
            if (this.form.rybh===''){
                this.$message.error('人员编号不能为空');
                return;
            }
            if (this.form.yzm.trim()===''){
                this.$message.error('验证码不能为空');
                this.form.yzm = '';
                return;
            }
            this.$api.examManageJnrd.evaluatorsLogin.login({
                data: this.form,
            }).then((res) => {
                console.log(res)
                // let state = res.data.data.State;
                // switch (state) {
                //     case 'Succees':
                //         this.$message.success('验证成功');
                //         const parts = window.location.href.split('/');
                //         parts.pop();
                //         window.location.href = parts.join('/')+'/candidateList?bh='+this.form.rybh;
                //         break;
                //     default:
                //         this.$message.error('登录失败，账号或密码错误');
                //         break;
                // }

                if (res.data.data.list != null) {
                    this.$message.success('登录成功');
                    this.loginzt = false;
                    if (res.data.data.list.sftz==='1'){
                        this.title = '确认监考时间';
                    }
                    if (res.data.data.list.sftz==='4'){
                        this.title = '确认监考场地';
                    }
                    if (res.data.data.list.sfjs==='1' || res.data.data.list.sfjs==='4') {
                        this.buttomShow = true;
                    } else {
                        this.buttomShow = false;
                    }
                    this.ksapid = res.data.data.list.ksapid;
                    this.jklx = res.data.data.list.jklx;
                    // 拿到返回值之后先根据是否接受的值判断标题显示的内容 用考试安排编号查询出所有信息之后进行回显
                    this.queryKsapById(res.data.data.list.ksapid);
                } else {
                    this.$message.error('登录失败，账号或密码错误');
                    this.loginzt = true;
                    // showNotify('错误', '登录失败', 'error', 3000);
                }
            }).catch((error) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        queryKsapById(ksapid){
            this.$api.examManageJnrd.evaluatorsLogin.queryKsapById({
                data: {
                    'ksapid': ksapid,
                },
            }).then((res) => {
                console.log('考试安排数据信息：',res)
                this.editExamInfo(res.data.data.list)
            }).catch((err) => {
                console.log(err);
            });
        },
        //编辑考试安排信息
        editExamInfo(row){
            this.editForm.id = row.id;
            this.editForm.ksbh = row.ksbh;
            this.editForm.zsmc = row.zsmc;
            this.editForm.kcbh = row.kcbh;
            this.editForm.kcmc = row.kcmc;
            this.editForm.ksrq = row.ksrq;
            this.editForm.kskssj = row.kskssj;
            this.editForm.ksjssj = row.ksjssj;
            this.editForm.jkry = row.jkry;
            this.editForm.ddry = row.ddry;
            this.editForm.xkry = row.xkry;
            this.editForm.zkry = row.zkry;
            this.editForm.kscd = row.kscd;
            this.editForm.kskcbid = row.kskcbid;
            this.editForm.kscc = row.kscc;
            this.editForm.ksqk = row.ksqk;
        },
        formatzsmc(row) {
            return this.getValueByKey(this.zsmc,row.zsmc);
        },
        formatksqk(row) {
            return this.getValueByKey(this.ksqk,row.ksqk);
        },
        formatjkry(row) {
            let jkrystr = '';
            let jkrys = (row.jkry+"").split(",");
            if (jkrys.length>0){
                for (let i = 0; i < jkrys.length; i++) {
                    if (i!==jkrys.length-1){
                        jkrystr += this.getValueByKey(this.people,jkrys[i])+',';
                    } else {
                        jkrystr += this.getValueByKey(this.people,jkrys[i]);
                    }
                }
            }
            return jkrystr;
        },
        formatddry(row) {
            let ddrystr = '';
            let ddrys = (row.ddry+"").split(",");
            if (ddrys.length>0){
                for (let i = 0; i < ddrys.length; i++) {
                    if (i!==ddrys.length-1){
                        ddrystr += this.getValueByKey(this.people,ddrys[i])+',';
                    } else {
                        ddrystr += this.getValueByKey(this.people,ddrys[i]);
                    }
                }
            }
            return ddrystr;
        },
        formatxkry(row) {
            let xkrystr = '';
            let xkrys = (row.xkry+"").split(",");
            if (xkrys.length>0){
                for (let i = 0; i < xkrys.length; i++) {
                    if (i!==xkrys.length-1){
                        xkrystr += this.getValueByKey(this.people,xkrys[i])+',';
                    } else {
                        xkrystr += this.getValueByKey(this.people,xkrys[i]);
                    }
                }
            }
            return xkrystr;
        },
        formatkscd(row) {
            let kscdstr = '';
            let kscds = (row.kscd+"").split(",");
            if (kscds.length>0){
                for (let i = 0; i < kscds.length; i++) {
                    if (i!==kscds.length-1){
                        kscdstr += this.getValueByKey(this.address,kscds[i])+',';
                    } else {
                        kscdstr += this.getValueByKey(this.address,kscds[i]);
                    }
                }
            }
            return kscdstr;
        },
        formatkssj(row) {
            if (row.kskssj==null){
                return '';
            }
            return row.kskssj+'~'+row.ksjssj;
        },
        getValueByKey(arr, keyToFind) {
            const item = arr.find(item => item.comboValue === keyToFind);
            return item ? item.comboName : '';
        },
        initCombo() {
            this.$api.examManageJnrd.evaluatorsLogin.initCombo({}).then((res) => {
                this.zsmc = res.data.data.zsmc;
                this.ksqk = res.data.data.ksqk;
                this.people = res.data.data.people;
                this.site = res.data.data.site;
                this.address = res.data.data.address;
            }).catch((err) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        sfjsksap(sfjs){
            if (sfjs==='2'){
                this.sfjsMessage = '接受考试安排';
            } else if(sfjs==='3'){
                this.sfjsMessage = '拒绝考试安排';
            }
            this.editSfjs(sfjs);
        },
        editSfjs(sfjs){
            this.sfjs = sfjs;
            this.$confirm(this.sfjsMessage+', 是否确定?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //打开签名弹框
                this.signVisable = true;
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        closeSignDialog(){
            this.$refs.esign.isClearBgColor; // 调用清空方法
        },
        esignSave() {
            this.$refs.esign.generate().then((res) => {
                // 文件版本
                var arr = res.split(','), mime = arr[0].match(/:(.*?);/)[1];
                var bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                var obj = new Blob([u8arr], {type: mime});
                var formData = new FormData();
                formData.append("file", obj, "image.png");
                this.$api.examManageJnrd.evaluatorsLogin.esignSave({
                    data: formData,
                }).then((res) => {
                    console.log('签名返回值：',res)
                    console.log('签名文件名：',res.data.data.filepath)
                    this.editjszt(res.data.data.filepath);
                    this.signVisable = false;
                    this.esignReset();//清空模板
                }).catch((error) => {
                    this.signVisable = false;
                    this.esignReset();//清空模板
                });

            }).catch((err) => {
                console.log(err);
            });
        },
        esignReset() {
            if (this.$refs.esign){
                this.$refs.esign.reset();
            }
        },
        //改变是否接受值
        editjszt(fileName){
            this.$api.examManageJnrd.evaluatorsLogin.editSfjs({
                data: {
                    'ksapid': this.ksapid,
                    'zh': this.form.rybh,
                    'jklx': this.jklx,
                    'sfjs': this.sfjs,
                    'dzqm': fileName,
                },
            }).then((res) => {
                if (res.data.data === 'success') {
                    showNotify('成功', '保存成功', 'success', 1500);
                    this.queryKsapById(this.ksapid);
                    this.queryhxjsinfo();
                } else if (res.data.data === 'sxrsym'){
                    showNotify('错误', '所需人数已满', 'error', 3000);
                } else if (res.data.data === 'fail'){
                    showNotify('错误', '保存失败', 'error', 3000);
                }
            }).catch((error) => {
            });
        },
        queryhxjsinfo(){
            this.$api.examManageJnrd.evaluatorsLogin.queryhxjsinfo({
                data: {
                    'ksapid': this.ksapid,
                    'zh': this.form.rybh,
                    'jklx': this.jklx,
                },
            }).then((res) => {
                console.log('返回值：',res)
                if (res.data.data.list.sfjs==='1' || res.data.data.list.sfjs==='4') {
                    this.buttomShow = true;
                } else {
                    this.buttomShow = false;
                }
            }).catch((error) => {
            });
        },

    }
}
</script>

<style scoped>

</style>
<style scoped>
.formElement{
    background-color:rgba(255,255,255,0.4);
    padding:30px 30px
}
.text {
    font-size: 14px;
}

.item {
    padding: 18px 0;
}

.box-card {
    width: 800px;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// evaluatorsLogin.vue?a6ccb1a4